import { isAnimationControls } from "../../animation/utils.mjs";
import { Feature } from "../feature.mjs";
class AnimationFeature extends Feature {
  constructor(state) {
    super(state);
  }
  updateAnimationControlsSubscription() {
    const { animate } = this.state.options;
    if (isAnimationControls(animate)) {
      this.unmountControls = animate.subscribe(this.state);
    }
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate } = this.state.options;
    const { animate: prevAnimate } = this.state.visualElement.prevProps || {};
    if (animate !== prevAnimate) {
      this.updateAnimationControlsSubscription();
    }
  }
  unmount() {
    var _a;
    (_a = this.unmountControls) == null ? void 0 : _a.call(this);
  }
}
export {
  AnimationFeature
};
